// FILTER BAR ELEMENTS
export const enableCategoriesFilter = true
export const enableDateFilter = true
export const enableLocationsFilter = true
export const enableViewFilter = false
export const enableCategoreisFilterLabel = false
export const enableDateFilterLabel = false
export const enableLocationsFilterLabel = false

// FILTER STATUS BAR
export const enableClearAllFilter = true
export const filterStatusDateFormat = 'D'
export const filterStatusMonthDateFormat = 'MMM. D'
export const filterStatusYearMonthDateFormat = 'MMM D, YYYY'

// EVENT CARDS
export const enableLoadMoreEventCards = true
export const eventCardEventTimeFormat = 'StartTime-EndTime'
export const eventCardTimeFormat = 'h:mma'
export const eventCardsPerPage = 9

// CALENDAR
export const calendarCellMaxEvents = 3
export const calendarCellDateFormat = 'D'
export const calendarCellHeadingsDateFormat = 'dd'
export const calendarPopoverEventTimeFormat = 'h:mma'
export const calendarPopoverTitleDateFormat = 'dddd, MMMM Do'
export const calendarTitleDateFormat = 'MMMM YYYY'
